import { Box, Typography, IconButton } from "@mui/material";
import { ArrowBack, ArrowForward, FitnessCenter, CheckCircle, Edit } from "@mui/icons-material";

const MobileBottomNav = ({
  planState,
  activeTab,
  setActiveTab,
  editMode,
  setEditMode,
  onNavigateForward,
  onNavigateBackward,
  workouts,
  isPlanActive,
  isWorkoutCompleted
}) => {
  return (
    <Box
      sx={{
        position: "fixed",
        bottom: 0,
        left: 0,
        right: 0,
        backgroundColor: "#FFFFFF",
        borderTop: "1px solid #E2E8F0",
        padding: "8px 12px",
        paddingBottom: "calc(8px + env(safe-area-inset-bottom, 0px))",
        zIndex: 1000,
        direction: "rtl"
      }}
    >
      {/* Week/Block Navigation Row */}
      <Box sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        marginBottom: "8px"
      }}>
        {/* Edit Button */}
        <IconButton
          disabled={!isPlanActive || isWorkoutCompleted || editMode}
          onClick={() => setEditMode(true)}
          size="small"
          sx={{
            backgroundColor: editMode ? "#E2E8F0" : "#F1F5F9",
            color: editMode ? "#94A3B8" : "#1E293B",
            "&:disabled": { backgroundColor: "#F8FAFC", color: "#CBD5E1" }
          }}
        >
          <Edit sx={{ fontSize: "18px" }} />
        </IconButton>

        {/* Navigation Controls */}
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <IconButton
            disabled={editMode}
            onClick={onNavigateBackward}
            size="small"
            sx={{
              backgroundColor: "#F1F5F9",
              "&:disabled": { backgroundColor: "#F8FAFC" }
            }}
          >
            <ArrowForward sx={{ fontSize: "18px" }} />
          </IconButton>

          <Typography sx={{
            fontSize: "13px",
            fontWeight: 600,
            color: "#1E293B",
            minWidth: "100px",
            textAlign: "center"
          }}>
            בלוק {(planState?.blockIdx || 0) + 1} / שבוע {(planState?.weekIdx || 0) + 1}
          </Typography>

          <IconButton
            disabled={editMode}
            onClick={onNavigateForward}
            size="small"
            sx={{
              backgroundColor: "#F1F5F9",
              "&:disabled": { backgroundColor: "#F8FAFC" }
            }}
          >
            <ArrowBack sx={{ fontSize: "18px" }} />
          </IconButton>
        </Box>

        {/* Placeholder for symmetry */}
        <Box sx={{ width: "34px" }} />
      </Box>

      {/* Workout Tabs Row */}
      <Box sx={{
        display: "flex",
        justifyContent: "center",
        gap: 1,
        overflowX: "auto",
        WebkitOverflowScrolling: "touch",
        "&::-webkit-scrollbar": { display: "none" },
        msOverflowStyle: "none",
        scrollbarWidth: "none"
      }}>
        {workouts.map((workout, index) => {
          const isActive = activeTab === index + 1;
          const isCompleted = workout.stateType === "COMPLETED";

          return (
            <Box
              key={workout.id}
              onClick={() => !editMode && setActiveTab(index + 1)}
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 0.5,
                padding: "8px 16px",
                borderRadius: "20px",
                backgroundColor: isActive ? "#1E293B" : "#F1F5F9",
                cursor: editMode ? "default" : "pointer",
                opacity: editMode && !isActive ? 0.5 : 1,
                transition: "all 0.2s",
                minWidth: "fit-content"
              }}
            >
              <FitnessCenter sx={{
                fontSize: "14px",
                color: isActive ? "#FFFFFF" : isCompleted ? "#22C55E" : "#64748B"
              }} />
              <Typography sx={{
                fontSize: "13px",
                fontWeight: 600,
                color: isActive ? "#FFFFFF" : "#1E293B"
              }}>
                {index + 1}
              </Typography>
              {isCompleted && (
                <CheckCircle sx={{
                  fontSize: "12px",
                  color: isActive ? "#22C55E" : "#22C55E"
                }} />
              )}
            </Box>
          );
        })}
      </Box>
    </Box>
  );
};

export default MobileBottomNav;
